export const validateMessage = (message) => message.trim() !== ""

export const isValidMessage = (message) => {
    return !!message.trim() && /[a-zA-Z0-9]/.test(message)
}